<app-dropdown (opened)="onDropdownOpened()" #appDropdown>
  @let areUnreadNotifications = areUnreadTopNotificationsSignal();

  <div dropdownTrigger class="notification-dropdown-icon-container">
    @if (areUnreadNotifications) {
      <badge-component
        class="badge-notifications"
        iconClassName="bi bi-bell"
        dropdownTrigger
        text=""
        textAlternative="{{
          'header.notificationsDropdown.iconTextAlt' | translate
        }}"
      />
    } @else {
      <i dropdownTrigger class="bi bi-bell badge-notifications"></i>
    }
  </div>

  <div class="notification-dropdown-content" dropdownContent #dropdownContent>
    <div class="notification-dropdown-title">
      <span>{{ "header.notificationsDropdown.title" | translate }}</span>
    </div>
    @let calloutConfigArray = topNotificationsBuiltCalloutsSignal();

    <div class="notification-dropdown-notifications">
      @for (notification of calloutConfigArray; track $index) {
        <div class="notification-dropdown-subtitle">
          <span>{{
            elapsedHeaderNotificationsTimeTitlesSignal()[$index]
          }}</span>
        </div>
        @if (renderCalloutsSignal()) {
          <div class="callout-wrapper callout-notifications">
            <app-callout
              inViewport
              [inViewportThreshold]="0.5"
              inViewportTargetSelector=".titulo-callout"
              [inViewportDelayMs]="500"
              (inViewport)="onNotificationsHeaderCalloutView($index)"
              [calloutData]="calloutConfigArray[$index]"
              [limitCharsTruncateText]="limitCharsTruncateText"
              (calloutFirstButtonEmitter)="
                acessSelectedTopNotificationArea($index)
              "
            />
          </div>
        }
      }

      @if (calloutConfigArray.length === 0) {
        <span>
          {{
            "header.notificationsDropdown.noNotificationsFound" | translate
          }}</span
        >
      }

      <div class="notifications-dropdown-navigate">
        <button-component
          appDropdownClose
          text="header.notificationsDropdown.goToNotificationsPage"
          customId="goToNotifications"
          [tmobBtnStyle]="tertiaryButton"
          (click)="goToNotificationsPage()"
        />
      </div>
    </div>
  </div>
</app-dropdown>
